"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _reactSwipeableViewsUtils = require("react-swipeable-views-utils");

var _Pagination = _interopRequireDefault(require("./Pagination"));

var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {
        position: 'relative',
        width: '100%'
      }
    }
  );
}, {
  name: 'SxWebJumbotron'
});
var AutoPlaySwipeableViews = (0, _reactSwipeableViewsUtils.autoPlay)(_reactSwipeableViews.default);

function Jumbotron(_ref) {
  var autoplayInterval = _ref.autoplayInterval,
      children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      pagination = _ref.pagination,
      PaginationProps = _ref.PaginationProps,
      jSize = _ref.size,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["autoplayInterval", "children", "classes", "className", "pagination", "PaginationProps", "size"]);
  var classes = useStyles({
    classes: pClasses
  });

  var _React$useState = _react.default.useState(0),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      index = _React$useState2[0],
      setIndex = _React$useState2[1];

  var handleChangeIndex = _react.default.useCallback(function (i) {
    setIndex(i);
  }, []);

  return _react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, className)
  }, _react.default.createElement(AutoPlaySwipeableViews, (0, _extends2.default)({}, rest, {
    index: index,
    onChangeIndex: handleChangeIndex,
    animateHeight: true,
    enableMouseEvents: true,
    interval: autoplayInterval,
    className: (0, _clsx.default)(classes.root, className)
  }), _react.default.Children.map(children, function (child) {
    return _react.default.cloneElement(child, {
      size: jSize
    });
  })), pagination && _react.default.createElement(_Pagination.default, (0, _extends2.default)({}, PaginationProps, {
    className: classes.pagination,
    dots: _react.default.Children.count(children),
    index: index,
    onChangeIndex: handleChangeIndex
  })));
}

Jumbotron.propTypes = {
  autoplayInterval: _propTypes.default.number,
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    'custom-height': _propTypes.default.string,
    'height-auto': _propTypes.default.string,
    pagination: _propTypes.default.string,
    root: _propTypes.default.string,
    s40: _propTypes.default.string,
    s60: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  // getActiveSlide: PropTypes.func,
  pagination: _propTypes.default.bool,
  PaginationProps: _propTypes.default.shape({}),
  size: _propTypes.default.oneOfType([_propTypes.default.number, // pro vysku v px
  _propTypes.default.oneOf(['auto', 's40', 's60'])])
};
Jumbotron.defaultProps = {
  autoplayInterval: 3000,
  children: null,
  classes: undefined,
  className: undefined,
  // getActiveSlide: undefined,
  pagination: false,
  PaginationProps: undefined,
  size: 's40'
};
var _default = Jumbotron;
exports.default = _default;